module.exports = __webpack_public_path__ + "img/arrow-back.a927fbc4.svg";